import { Editor, Element, Range, Transforms, Point } from 'slate';

import { CustomElementTypes } from '../types';

import { isElementVoid, isBlockActive } from './utils';

const CUSTOM_INLINE_ELEMENTS = ['link', 'mention'];

const SHORTCUTS = {
  '>': 'block-quote',
  '#': 'heading-1',
  '```': 'code-block',
};

export const withSling = (editor: Editor): Editor => {
  const { isInline, isVoid, insertText, insertData, deleteBackward } = editor;

  editor.isInline = (element: Element): boolean => {
    return CUSTOM_INLINE_ELEMENTS.includes(element.type) || isInline(element);
  };

  editor.isVoid = (element: Element): boolean => {
    return isElementVoid(element) || isVoid(element);
  };

  // @TODO find out why slate and react 18 make it editor to crash
  // editor.insertText = (text): void => {
  //   if (!text) {
  //     return;
  //   }

  //   const { selection } = editor;
  //   if ((text === ' ' || text === '`') && selection && Range.isCollapsed(selection)) {
  //     const { type, range } = getShortcutData(editor, selection, text);
  //     if (type) {
  //       handleShortcut(editor, range, type);
  //       return;
  //     }
  //   }

  //   insertText(text);
  // };

  editor.deleteBackward = (...args): void => {
    const { selection } = editor;

    if (selection && Range.isCollapsed(selection)) {
      const match = Editor.above(editor, {
        match: (n) => Element.isElement(n) && Editor.isBlock(editor, n),
      });

      if (match) {
        const [block, path] = match;
        const start = Editor.start(editor, path);

        if (
          !Editor.isEditor(block) &&
          Element.isElement(block) &&
          block.type !== 'paragraph' &&
          Point.equals(selection.anchor, start)
        ) {
          const newProperties: Partial<Element> = {
            type: 'paragraph',
          };
          Transforms.setNodes(editor, newProperties);

          return;
        }
      }

      deleteBackward(...args);
    }
  };

  editor.insertData = (data): void => {
    const text = data.getData('text/plain');

    if (text) {
      if (isBlockActive(editor, 'block-quote') || isBlockActive(editor, 'code-block')) {
        insertText(text);
        return;
      }

      insertData(data);
    }
  };

  return editor;
};

type ShortcutData = {
  type?: CustomElementTypes;
  beforeText: string;
  range: Range;
};

function getShortcutData(editor: Editor, selection: Range, text: string): ShortcutData {
  const { anchor } = selection;
  const block = Editor.above(editor, {
    match: (n) => Element.isElement(n) && Editor.isBlock(editor, n),
  });
  const path = block ? block[1] : [];
  const start = Editor.start(editor, path);
  const range = { anchor, focus: start };
  const beforeText = Editor.string(editor, range);
  const key = text !== ' ' ? `${beforeText}${text}` : beforeText;
  const type = SHORTCUTS[key];

  return {
    beforeText,
    type,
    range,
  };
}

function handleShortcut(editor: Editor, range: Range, type: CustomElementTypes): void {
  Transforms.select(editor, range);
  Transforms.delete(editor);
  const newProperties: Partial<Element> = {
    type,
  };
  Transforms.setNodes(editor, newProperties, {
    match: (n) => Element.isElement(n) && Editor.isBlock(editor, n),
  });
}
